// import { useSelector } from "react-redux";

// const useOfferConfig = (name) => {
//   const config = useSelector((state) => state.offer.offerConfigData?.[name]);
//   const loading = useSelector((state) => state.offer.loadingByKey?.[name]);
//   const error = useSelector((state) => state.offer.errorByKey?.[name]);
//   const success = useSelector((state) => state.offer.successMessageByKey?.[name]);

//   return { config, loading, error, success };
// };

// export default useOfferConfig;

import { useSelector } from "react-redux";

const useOfferConfig = (name) => {
  const config = useSelector((state) => state.offer.offerConfigData?.[name] || null);
  const loading = useSelector((state) => state.offer.loadingByKey?.[name] || false);
  const error = useSelector((state) => state.offer.errorByKey?.[name] || null);
  const success = useSelector((state) => state.offer.successMessageByKey?.[name] || null);

  return { config, loading, error, success };
};

export default useOfferConfig;
